// extracted by mini-css-extract-plugin
export var grid = "grid-module--grid--fc22a";